module.exports = __webpack_public_path__ + "img/wonderegypt_tech_Normal_ua.898aa443.webp";